import { Navigate, RouteObject, useRoutes } from 'react-router-dom';

import { NotFound } from '@/features/misc';
import { useAuth } from '@/hooks/useAuth';

import { protectedRoutes } from './protected';
import { publicRoutes } from './public';

export const AppRoutes = () => {
  const { isAuthenticated } = useAuth();

  const redirectRoute = { path: `*`, element: <Navigate to="/login" /> };

  let routes: RouteObject[] = [...publicRoutes, redirectRoute];

  const exceptionRoutes = [{ path: `*`, element: <NotFound /> }];

  if (isAuthenticated()) {
    routes = [...protectedRoutes, { path: `/login`, element: <Navigate to="/" /> }];
  }

  const element = useRoutes([...routes, ...exceptionRoutes]);

  return element;
};
